import React from 'react';

import { Step } from 'components/Wizard';
import TemplateWizardProgressStep, {
  TemplateWizardProgressStepProps,
} from '../../TemplateWizardProgressStep';
import { TemplateWizardErrorHandler } from '../../types';
import { AudioFlowStep } from './types';

type UseProgressStepConfig = Pick<
  TemplateWizardProgressStepProps,
  'onCompleted'
> & {
  onError: TemplateWizardErrorHandler;
};
interface UseProgressStepResult {
  step: Step<AudioFlowStep.SUBMITTING>;
}

export default function useProgressStep(
  props: UseProgressStepConfig,
): UseProgressStepResult {
  return {
    step: {
      component: <TemplateWizardProgressStep {...props} />,
      name: 'Creating Project',
      renderCancelButton: () => null,
      renderNextButton: () => null,
      showInNav: false,
      stepId: AudioFlowStep.SUBMITTING,
    },
  };
}
